module.exports = __webpack_public_path__ + "img/circle-w.8fc78124.svg";